import { Checkbox, Label } from "flowbite-react";

const CheckboxInput = ({
  legend,
  data,
  isFilter = false,
  defaultChecked = false,
  onChange,
}) => {
  return (
    <fieldset className="flex max-w-md flex-col gap-2">
      {legend && <legend className="mb-4">{legend}</legend>}
      {!!data.length &&
        data.map((item, index) => (
          <div key={index} className="flex items-center gap-2">
            <Checkbox
              id={item.id}
              name="data"
              value={item.value}
              defaultChecked={isFilter ? item.value === "USA" : defaultChecked}
              disabled={item.disabled}
              className={"w-5 h-4 rounded-1 border-gray-200 bg-white"}
              onChange={onChange}
            />
            <Label htmlFor={item.id} disabled={item.disabled}>
              {item.name} {item.disabled && "(disabled)"}
            </Label>
          </div>
        ))}
    </fieldset>
  );
};
export default CheckboxInput;
